import React from 'react';
import { SelectIdPCallback } from '@forgerock/javascript-sdk';
import { Icons } from 'Assets';
import { SOCIAL_CONNECT_PENDING, useAppContext, useJourneyContext } from 'Contexts';
import { Origin } from 'Constants';
import { TrackingService } from 'Services';
import { Button } from 'Components';

interface ButtonProps {
  uiConfig: UiConfig;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
}

const SocialButton: React.FC<ButtonProps> = ({ uiConfig, onClick }) => (
  <>
    <style>
      {`
        .button {
          ${uiConfig.buttonCustomStyle}
        }
        .button:hover {
          ${uiConfig.buttonCustomStyleHover}
        }
      `}
    </style>
    <Button className="md:w-full" onClick={onClick}>
      <img className="m-auto" src={getSocialIcon(uiConfig.buttonImage)} alt={`Bouton social login ${uiConfig.buttonDisplayName}`} />
    </Button>
  </>
);

const getSocialIcon = (name: string) => {
  switch (name) {
    case 'images/paypal.svg':
      return Icons.Paypal;
    default:
      return undefined;
  }
};

interface ButtonsProps {
  selectIdPCallback: SelectIdPCallback;
  stage: Stage;
  origin: Origin;
  mobile: boolean;
}

export const SocialButtons: React.FC<ButtonsProps> = ({ selectIdPCallback, stage, origin, mobile }) => {
  const { eligibleToShortcutPaypal } = useAppContext();
  const { setStandardSubmit, isStandardSubmit } = useJourneyContext();
  isStandardSubmit && selectIdPCallback.setProvider('localAuthentication');
  const handleSocialConnect = (provider: string) => (event: React.MouseEvent<HTMLElement>) => {
    sessionStorage.removeItem(SOCIAL_CONNECT_PENDING);
    setStandardSubmit(false);
    selectIdPCallback.setProvider(provider);
    const eventId = TrackingService.buildEventIdClick(stage, 'click', origin) + '_' + provider;
    const path = TrackingService.buildPath(stage, mobile, origin);
    TrackingService.triggerTrackingClic(eventId, path, event);
  };
  const socialProviders = selectIdPCallback.getProviders().filter((pp) => pp.provider !== 'localAuthentication');
  return (
    <div className="w-full justify-center">
      {socialProviders.length > 0 && eligibleToShortcutPaypal && (
        <>
          <div
            key="social-login-or-divider"
            className="relative text-center before:absolute before:left-0 before:top-1/2 before:w-full before:bg-whitesmoke before:h-[1px]"
          >
            <span className="bg-white text-sonic-silver relative px-2.5">ou</span>
          </div>
          <div key="social-login-text" className="text-nero text-center text-sm py-5">
            Connectez-vous ou créez votre compte avec PayPal
          </div>
          {socialProviders.map(({ provider, uiConfig }) => (
            <SocialButton uiConfig={uiConfig as UiConfig} onClick={handleSocialConnect(provider)} key={provider} />
          ))}
        </>
      )}
    </div>
  );
};

interface UiConfig extends Record<string, string> {
  buttonDisplayName: string;
  iconBackground: string;
  buttonCustomStyle: string;
  buttonCustomStyleHover: string;
  buttonImage: string;
}
